import { useEffect } from 'react'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { matchRoute, navigate, useHashRoute } from './router/hash'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ClientsListPage } from './pages/ClientsListPage'
import { ClientDetailPage } from './pages/ClientDetailPage'
import { AddClientPage } from './pages/AddClientPage'
import { ModuleStubPage } from './pages/ModuleStubPage'
import { FoodPage } from './pages/FoodPage'

const PUBLIC_PATHS = new Set(['/', '/login'])

function Routes() {
  const path = useHashRoute()
  const { user, initializing } = useAuth()

  useEffect(() => {
    if (initializing) return
    const authed = !!user
    if (!authed && !PUBLIC_PATHS.has(path)) {
      navigate('/login')
      return
    }
    if (authed && (path === '/login' || path === '/')) {
      navigate('/dashboard')
    }
  }, [user, initializing, path])

  if (initializing) {
    return (
      <div className="auth" aria-busy="true">
        <div className="auth__panel">
          <div className="auth__form"><p>Restoring your session…</p></div>
        </div>
      </div>
    )
  }

  if (!user) {
    return <LoginPage />
  }

  if (path === '/clients/new') {
    return <AddClientPage currentPath={path} />
  }

  const editClient = matchRoute('/clients/:clientId/edit', path)
  if (editClient) {
    return <AddClientPage currentPath={path} clientId={editClient.params.clientId} />
  }

  const profile = matchRoute('/clients/:clientId/:tab', path)
  if (profile && profile.params.clientId !== 'new') {
    return (
      <ClientDetailPage
        clientId={profile.params.clientId}
        tabId={profile.params.tab}
        currentPath={path}
      />
    )
  }

  if (path === '/clients') {
    return <ClientsListPage currentPath={path} />
  }

  if (path === '/food') {
    return <FoodPage currentPath="/modules/food" />
  }

  const moduleMatch = matchRoute('/modules/:moduleId', path)
  if (moduleMatch) {
    if (moduleMatch.params.moduleId === 'food') {
      return <FoodPage currentPath={path} />
    }
    return <ModuleStubPage moduleId={moduleMatch.params.moduleId} currentPath={path} />
  }

  if (path === '/dashboard') {
    return <DashboardPage currentPath={path} />
  }

  return <DashboardPage currentPath={path} />
}

/** Root app — also the entry SPFx will mount later via `mountDaycareApp`. */
export function App() {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  )
}
